module.exports = __webpack_public_path__ + "img/tevredenheidsgarantie.9b71f7ac.jpg";